import { Panel } from "react-resizable-panels";
import styled from "@emotion/styled";

export const MDSPanel = styled(Panel)`
  width: 100%;
  height: 100%;
  container-type: inline-size;
  container-name: mds-panel;
`;
